import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FactorDetail,
  FactorDetailDrug,
  FactorStockItemDetailDrug,
} from '../../models/factor-detail';
import { FocusableHTMLElement } from '../../interfaces/focusable-html-element';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {
  BuyImportRequestDrugModal,
  BuyImportRequestDrugStockModal,
  BuyImportRequestValidationDrugModal,
  StockHelpItem,
} from '../../models/buy-import-modal';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { NewCalendarService } from 'src/app/services/new-calender-service';

@Component({
  selector: 'app-remove-lack',
  templateUrl: './remove-lack.component.html',
  styleUrls: ['./remove-lack.component.css'],
})
export class RemoveLackComponent {
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;

  @Input() data: FactorDetail;
  @Input() stockList: any[];
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  public editableItem: BuyImportRequestDrugModal;
  public editableItemMessage: BuyImportRequestValidationDrugModal =
    new BuyImportRequestValidationDrugModal();
  public countMessage: string = ``;
  public newItem: any = { count: '', stockId: '' };
  public modalIsOpen: boolean;
  public EditItem: boolean = false;
  public loading: boolean = false;
  public monthName: string = '';
  private focusableItems: FocusableHTMLElement[] = [];
  private rememberItem?: FocusableHTMLElement;
  public stockHelpItem: StockHelpItem;
  public modalSuccessConfirm: boolean = false;

  constructor(
    private logger: LoggerService,
    private calendarService: NewCalendarService,
    private modalService: NgbModal,
    public apiService: UserApiService
  ) {
    this.stockList = [];
    this.stockHelpItem = new StockHelpItem();
    this.data = new FactorDetail();
    this.modalIsOpen = false;
    this.editableItem = new BuyImportRequestDrugModal(this.calendarService.GetNow());
  }


  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
    }
  }


  public packageKeyUp() {
    if (!this.checkValidationCount()) {
      return;
    }

    this.editableItem.count =
      this.editableItem.packageCount! * this.editableItem.drugPackageCount!;

    this.checkStockActivate();
  }

  public checkValidationCount(): boolean {
    if (
      this.editableItem.count == null &&
      this.editableItem.packageCount == null &&
      this.editableItem.drugPackageCount == null &&
      this.editableItem.lack == null &&
      this.editableItem.lack == 0
    ) {
      return false;
    }

    if (
      this.editableItem.packageCount! > this.editableItem.lack!
    ) {
      this.editableItem.packageCount = this.editableItem.lack;
      this.editableItem.count = this.editableItem.packageCount! * this.editableItem.drugPackageCount!;
      this.newItem.count = this.editableItem.packageCount;
      return false;
    }

    if (this.editableItem.count == null) {
      this.editableItem.count = 0;
    }

    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 0;
    }

    return true;
  }

  public setOnStockCount() {
    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 0;
    }
    this.newItem.count = this.editableItem.packageCount;
  }

  public checkStockActivate() {
    if (
      this.editableItem.count == undefined ||
      this.editableItem.count == 0 ||
      this.editableItem.packageCount == undefined ||
      this.editableItem.packageCount == 0
    ) {
      this.stockHelpItem.addCount = 0;
      this.stockHelpItem.maxCount = 0;
      this.stockHelpItem.isActive = false;
      return;
    }
  }

  public countKeyUp(): boolean {
    if (!this.checkValidationCount()) {
      return false;
    }

    if (this.editableItem.count! % this.editableItem.drugPackageCount! != 0) {
      if (this.countMessage == ``) {
        this.countMessage = `مغایرت در بسته بندی`;
      }
      return false;
    } else {
      this.editableItem.packageCount = this.editableItem.lack;
      this.editableItem.packageCount =
        this.editableItem.count! / this.editableItem.drugPackageCount!;
      const shortageCount = this.editableItem.lack! - this.editableItem.packageCount!;
      return true;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public generateFocusList() {
    var elements = document.getElementsByClassName('Focusable');
    this.focusableItems = Array.from(elements).map((element, index) => ({
      index,
      element: element as HTMLElement,
    }));
  }

  public nextFocus() {
    if (this.focusableItems.length == 0) {
      this.generateFocusList();
    }

    let focusedElement = document.activeElement;

    let currentItemInArray = this.focusableItems.find(
      (current) =>
        current.element.id == focusedElement?.id &&
        current.element.classList == focusedElement?.classList
    );

    if (currentItemInArray == null && this.rememberItem != null) {
      if (
        this.rememberItem.element.className.indexOf('drop-down-box') >= 0 &&
        this.rememberItem.element.className.indexOf('drop-down-box-open') >= 0
      ) {
        return;
      } else {
        currentItemInArray = this.rememberItem;
      }
    }

    const currentItemIndex =
      currentItemInArray == undefined ? 0 : currentItemInArray.index + 1;

    const nextItemIndex =
      currentItemIndex == this.focusableItems.length ? 7 : currentItemIndex;

    const needFocus = this.focusableItems[nextItemIndex];

    needFocus.element.focus();
    this.rememberItem = needFocus;

    if (needFocus.element instanceof HTMLInputElement) {
      needFocus.element.select();
    }
  }

  public startEdit(item: FactorStockItemDetailDrug, index: number) {
    this.editableItem.index = index;
    this.editableItem.drugName = item.drugName;
    this.editableItem.liveLack = item.liveLack ?? 0;
    this.editableItem.drugId = item.drugId;
    this.editableItem.lack = item.shortageCount;
    this.editableItem.packageCount = 0;
    this.editableItem.drugPackageCount = item.packageCount; //TODO Backend Not Send drugPackageCount
    this.editableItem.count = 0;
    this.editableItem.expireDate = item.expireDate;
    this.editableItem.id = item.buyFactorDetailId;
    this.editableItem.lot = item.lot;
    this.EditItem = true;
  }

  public saveAdd() {
    try {

      this.loading = true;
      let url = `BuyFactor/ReduceShortage`;

      let inventoryDetail: any[] = [];
      this.editableItem.stocks.forEach(element => {
        const itemInventory = {
          stockId: element.stockId,
          count: (element.count??1) * (this.editableItem.drugPackageCount ?? 1)
        };

        inventoryDetail.push(itemInventory);
      });
      this.editableItem.stocks
      let backendJson = {
        id: this.editableItem.id,
        count: this.editableItem.count,
        drugPackageCount: this.editableItem.drugPackageCount,
        expireDate: this.editableItem.expireDate,
        lot: this.editableItem.lot,
        inventoryDetails: inventoryDetail
      }

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.parentActionOutput.next(new PCTableOutputModel('SuccessRemoveShortage', null));
          
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public exit() {
    this.editableItem = new BuyImportRequestDrugModal(this.calendarService.GetNow());
    this.EditItem = false;
  }

  public removeStock(index: number) {
    const removeItem = this.editableItem.stocks[index];

    this.editableItem.stocks.splice(index, 1);

    this.stockHelpItem.addCount = 0;
    this.editableItem.stocks.forEach((element) => {
      this.stockHelpItem.addCount += element.count!;
    });
    if (this.editableItem.lack != null && this.editableItem.lack > 0) {
      this.stockHelpItem.addCount += this.editableItem.lack;
    }

    if (this.stockHelpItem.addCount == this.stockHelpItem.maxCount) {
      this.stockHelpItem.isActive = false;
    } else {
      this.stockHelpItem.isActive = true;
    }

    this.editableItem.packageCount = this.editableItem.lack! - this.stockHelpItem.addCount;
    this.editableItem.count = this.editableItem.packageCount! * this.editableItem.drugPackageCount!;
    this.newItem.count = 0;
    this.newItem.count =
      this.stockHelpItem.maxCount - this.stockHelpItem.addCount;
  }

  public addStock() {
    try {
      if (this.newItem.count == null || this.newItem.count == 0) {
        this.logger.addError(
          'تعداد در انبار نمیتواند خالی و یا صفر باشد',
          false
        );
        return;
      }

      if (this.newItem.stockId == null || this.newItem.stockId == '') {
        this.logger.addError('لطفا یک انبار را انتخاب نمایید ', false);
        return;
      }

      if (this.editableItem.stocks.length >= 3) {
        this.logger.addError(
          'امکان انتقال یک دارو به بیش از 3 انبار امکان پذیر نیست ',
          false
        );
        return;
      }

      if (this.editableItem.packageCount! > this.editableItem.lack!) {
        this.logger.addError(
          'e',
          false
        );
        this.newItem.count =
          this.stockHelpItem.maxCount - this.stockHelpItem.addCount;
        return;
      }

      if (this.newItem.count! > this.editableItem.lack!) {
        this.logger.addError(
          'e',
          false
        );
        this.newItem.count =
          this.stockHelpItem.maxCount - this.stockHelpItem.addCount;
        return;
      }

      this.stockHelpItem.addCount = 0;
      this.editableItem.stocks.forEach((element) => {
        this.stockHelpItem.addCount += element.count!;
      });


      const stock = this.stockList.find(
        (current) => current.id == this.newItem.stockId
      );

      const newItemCopy: BuyImportRequestDrugStockModal = {
        count: this.newItem.count,
        stockName: stock.persianName,
        stockId: this.newItem.stockId,
      };
      this.editableItem.stocks.push(newItemCopy);

      this.stockHelpItem.addCount = 0;
      this.editableItem.stocks.forEach((element) => {
        this.stockHelpItem.addCount += element.count!;
      });

      if (this.stockHelpItem.addCount == this.editableItem.lack!) {
        this.stockHelpItem.isActive = false;
      } else {
        this.stockHelpItem.isActive = true;
      }

      // if (this.stockHelpItem.addCount > this.editableItem.lack!) {
      //   this.editableItem.lack! -= this.newItem.count
      // }

      this.newItem.count = this.editableItem.packageCount! - this.stockHelpItem.addCount;
      this.editableItem.count = this.editableItem.packageCount! * this.editableItem.drugPackageCount!;

      if (this.stockHelpItem.maxCount > this.editableItem.lack!) {
        this.editableItem.packageCount == 0;
        this.newItem.count = this.editableItem.lack!;
      }

      this.newItem.stockId = '';
    } catch (e) {
      this.logger.addException(e, false);
    }
  }


}
